import type { RootState } from "@/app/redux/store";
import { useToken } from "@/app/services/context/TokenContext";
import { ICON_BASE_PATH } from "@/app/utils/config";
import { redirectToGrowXLogout } from "@/app/utils/loginservice/redirectToGrowXLogout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const ConsentRevoked = () => {
  const navigate = useNavigate();
  const userData = useSelector((state: RootState) => state.userData.data);
  const lfiHolder = userData?.lfiHolder;
  const isConsentChecked = userData?.isConsentChecked;

  const { logout } = useToken();

  /* ---------------- LOGOUT ---------------- */

  const handleLogout = () => {
    setTimeout(redirectToGrowXLogout, 0);
    logout();
  };

  /* ---------------- CONNECT BANK ---------------- */

  const handleConnect = async () => {
    navigate("/onboarding/connectBank");
  };

  return (
    <div className="gx-login-card gx-consent-login">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <div className="gx-consents-animation">
            <img src={`${ICON_BASE_PATH}consent_warning.svg`} alt="Consent" />
          </div>
        </div>

        <div className="col-span-12">
          <div className="gx-login-success-title">
            <h2 className="gx-h2-l">
              Consent <span className="gx-h2-b">Revoked</span>
            </h2>

            {isConsentChecked === "Y" && lfiHolder === "Y" ? (
              <p className="gx-p12-m">
                Your consent for one or more accounts has been revoked by
                <strong> Bank or your administrator</strong>. You need to
                connect your bank account to continue
              </p>
            ) : (
              <p className="gx-p12-m">
                Your consent for one or more accounts has been revoked by
                <strong> Bank or your administrator</strong>. please contact
                your administrator or GrowX support@growx.global for further
                information.
              </p>
            )}
          </div>
        </div>

        <div className="col-span-12">
          {lfiHolder === "Y" && (
            <div className="login-continue-btn gx-signin-btn">
              <button onClick={handleConnect} className="gx-p16-eb">
                Connect Bank Account
              </button>
            </div>
          )}

          <div className="gx-connectbank-logout">
            <button onClick={handleLogout}>
              <img src={`${ICON_BASE_PATH}logouticon.svg`} alt="logout" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
